<script lang="ts">
  import { onMount } from "svelte";

  export let name: string;
  export let value: number, maxValue: number;
  export let bg: string;
  export let fg: string;

  let canvas: HTMLCanvasElement;
  let PR = 1;
  let min = Infinity,
    max = 0,
    round = Math.round;

  let WIDTH = 80 * PR,
    HEIGHT = 32 * PR,
    TEXT_X = 3 * PR,
    TEXT_Y = 2 * PR,
    GRAPH_X = 3 * PR,
    GRAPH_Y = 15 * PR,
    GRAPH_WIDTH = 74 * PR,
    GRAPH_HEIGHT = 30 * PR;

  onMount(() => {
    const ctx = canvas.getContext("2d");
    PR = round(window.devicePixelRatio || 1);
    (WIDTH = 80 * PR),
      (HEIGHT = 32 * PR),
      (TEXT_X = 3 * PR),
      (TEXT_Y = 2 * PR),
      (GRAPH_X = 3 * PR),
      (GRAPH_Y = 15 * PR),
      (GRAPH_WIDTH = 74 * PR),
      (GRAPH_HEIGHT = 30 * PR);
    if (!ctx) return;
    canvas.width = WIDTH;
    canvas.height = HEIGHT;
    canvas.style.cssText = "width:80px;height:32px";
    ctx.font =
      "bold " + 9 * PR + "px ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace";
    ctx.textBaseline = "top";

    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, WIDTH, HEIGHT);

    ctx.fillStyle = fg;
    // ctx.fillText(name, TEXT_X, TEXT_Y);
    ctx.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);

    ctx.fillStyle = bg;
    ctx.globalAlpha = 0.9;
    ctx.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
  });

  function draw(
    ctx: CanvasRenderingContext2D | null,
    value: number,
    maxValue: number,
    bg: string,
    fg: string
  ) {
    if (!ctx) return;
    min = Math.min(min, value);
    max = Math.max(max, value);

    ctx.fillStyle = bg;
    ctx.globalAlpha = 1;
    ctx.fillRect(0, 0, WIDTH, GRAPH_Y);
    ctx.fillStyle = fg;
    ctx.fillText(
      round(value) + " " + name + " (" + round(min) + "-" + round(max) + ")",
      TEXT_X,
      TEXT_Y
    );

    ctx.drawImage(
      canvas,
      GRAPH_X + PR,
      GRAPH_Y,
      GRAPH_WIDTH - PR,
      GRAPH_HEIGHT,
      GRAPH_X,
      GRAPH_Y,
      GRAPH_WIDTH - PR,
      GRAPH_HEIGHT
    );

    ctx.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);

    ctx.fillStyle = bg;
    ctx.globalAlpha = 0.9;
    ctx.fillRect(
      GRAPH_X + GRAPH_WIDTH - PR,
      GRAPH_Y,
      PR,
      round((1 - value / maxValue) * GRAPH_HEIGHT)
    );
  }

  $: canvas && draw(canvas.getContext("2d"), value, maxValue, bg, fg);
</script>

<canvas bind:this={canvas} />
